exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".policy {\n  height: 100%;\n  background-color: #FCFCFC;\n  font-size: 0.28rem;\n  padding: 0.2rem;\n  line-height: 0.52rem;\n  color: #333333;\n}\n.policy h1 {\n  text-align: center;\n  font-size: 0.32rem;\n  font-weight: bold;\n}\n.policy h2 {\n  font-weight: bold;\n}\n.policy ul {\n  list-style: none;\n  padding-left: 0.48rem;\n}\n.policy ul li {\n  list-style: circle;\n}\n.policy a {\n  color: #6FB7FF;\n  word-break: break-all;\n}\n.policy .p_tit {\n  font-weight: bold;\n  color: #444;\n  text-align: left;\n  margin-top: 0.2rem;\n}\n.policy .contact {\n  color: #6FB7FF;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--2-1!../node_modules/postcss-loader!../node_modules/less-loader/dist/cjs.js!./pages/app/child_safety_policy/index.less
// module id = ../node_modules/css-loader/index.js??ref--2-1!../node_modules/postcss-loader/index.js!../node_modules/less-loader/dist/cjs.js!./pages/app/child_safety_policy/index.less
// module chunks = 0